// extracted by mini-css-extract-plugin
export var orderSummary = "_pq-0";
export var showMoreLessButton = "_pq-1";